import { getScrollContainer, getScrollEventTarget, getScrollTop, scrollContainerMediaQuery } from '@theme/scroll-container';

const sectionControllers = new WeakMap();

function getNextVisibleSection(hero) {
  const heroSection = hero.closest('.shopify-section');
  let candidate = heroSection?.nextElementSibling;

  while (candidate) {
    if (candidate.matches('.shopify-section') && !candidate.hidden && candidate.getClientRects().length > 0) {
      return candidate;
    }

    candidate = candidate.nextElementSibling;
  }

  return null;
}

function initIndicator(indicator) {
  sectionControllers.get(indicator)?.abort();

  const hero = indicator.closest('.fill-hero');
  if (!hero) return;

  const controller = new AbortController();
  const { signal } = controller;
  sectionControllers.set(indicator, controller);

  const updateVisibility = () => {
    indicator.dataset.scrollIndicatorVisible = getScrollTop() <= 16 ? 'true' : 'false';
  };

  const bindScrollTarget = () => {
    getScrollEventTarget().addEventListener('scroll', updateVisibility, { signal, passive: true });
    updateVisibility();
  };

  indicator.addEventListener(
    'click',
    () => {
      const target = getNextVisibleSection(hero);
      if (!target) return;

      const container = getScrollContainer();
      const top = target.getBoundingClientRect().top + container.scrollTop;
      container.scrollTo({
        top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    },
    { signal }
  );

  bindScrollTarget();
  scrollContainerMediaQuery.addEventListener('change', () => {
    controller.abort();
    initIndicator(indicator);
  }, { signal, once: true });
}

function initAll(root = document) {
  root.querySelectorAll?.('[data-fill-hero-scroll-indicator]').forEach(initIndicator);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
} else {
  initAll();
}

document.addEventListener('shopify:section:load', (event) => initAll(event.target));

document.addEventListener('shopify:section:unload', (event) => {
  event.target?.querySelectorAll?.('[data-fill-hero-scroll-indicator]').forEach((indicator) => {
    sectionControllers.get(indicator)?.abort();
    sectionControllers.delete(indicator);
  });
});
